// export const ARTICLE_PUBLISH = 'publishArticle'
// export const ARTICLE_DELETE = 'deleteArticle'
// export const ARTICLE_EDIT = 'editArticle'
// export const ARTICLE_EDIT_ADD_TAG = 'addTagToArticle'
// export const ARTICLE_EDIT_REMOVE_TAG = 'removeTagFromArticle'
// export const ARTICLE_RESET_STATE = 'resetArticleState'
export const CHECK_AUTH = 'checkAuth'
export const COMMENT_CREATE = 'createComment'
export const COMMENT_DESTROY = 'destroyComment'
export const FAVORITE_ADD = 'addFavorite'
export const FAVORITE_REMOVE = 'removeFavorite'
export const FETCH_ARTICLE = 'fetchArticle'
export const FETCH_ARTICLES = 'fetchArticles'
export const FETCH_COMMENTS = 'fetchComments'
export const FETCH_USER = 'fetchUser'
export const FETCH_PROFILE = 'fetchProfile'
export const FETCH_IMAGE = 'fetchImage'
export const FETCH_PROFILE_FOLLOW = 'fetchProfileFollow'
export const FETCH_PROFILE_UNFOLLOW = 'fetchProfileUnfollow'
export const FETCH_START = 'setLoading'
export const FETCH_TAGS = 'fetchTags'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const UPDATE_USER = 'updateUser'
export const FORGOT_PASSWORD = 'forgotPassword'

export const ADD_AGREEMENT = 'addAgreement'
export const DELETE_AGREEMENT = 'deleteAgreement'
export const EDIT_AGREEMENT = 'editAgreement'
export const FETCH_AGREEMENT = 'fetchAgreement'
export const FETCH_AGREEMENT_BY_REF = 'fetchAgreementByRef'
export const FETCH_AGREEMENTS = 'fetchAgreements'

export const UPDATE_USER_REQUEST_ACCESS_DATE = 'updateUserRequestAccessDate'
export const UPDATE_USER_REQUEST = 'updateUserRequest'

export const UPDATE_PROFILE = 'updateProfile'

export const ASSIGN_CURRENT_USER = 'assignCurrentUser'
export const ASSIGN_CURRENT_COMPANY = 'assignCurrentCompany'



// WEBPACK FOOTER //
// ./src/store/types/actions.type.js